import Layout from './Layout';
import Input from '../Common/Input';
import { Title, ForgotPasswordText } from './Login';
import { useNavigate } from 'react-router-dom';
import { Result } from '../Common/Result';
import { useState } from 'react';
import { Button, Form } from 'antd';

type Props = {
  onFinish: (values: any) => Promise<{
    success?: boolean;
    errors?: { field: string; errors: string[] }[];
  }>;
};
const ForgotPass = ({ onFinish }: Props) => {
  const navigate = useNavigate();
  const [showResult, setShowResult] = useState(false);

  const [form] = Form.useForm();
  const [isSubmiting, setIsSubmiting] = useState(false);
  const [email, setEmail] = useState('');

  if (showResult) {
    return (
      <Layout>
        <Result
          type="sendmailsuccess"
          // title="Mật khẩu cập nhật thành công."
          message={
            <span>
              Xác nhận khôi phục mật khẩu đã được gửi vào email. <b>{email}</b>{' '}
              Vui lòng kiểm tra hộp thư và làm theo hướng dẫn.
            </span>
          }
        />
      </Layout>
    );
  }
  return (
    <Layout>
      <Form
        layout="vertical"
        onFinish={async (value) => {
          setIsSubmiting(true);
          const res = await onFinish(value);
          if (res.success) {
            setShowResult(true);
          }
          if (res.errors) {
            const arr = res.errors.map((x) => {
              return {
                name: x.field,
                errors: x.errors,
              };
            });
            form.setFields(arr);
            form.scrollToField(arr[0].name);
          }
          setIsSubmiting(false);
        }}
        validateTrigger="onSubmit"
      >
        <Title>Bạn quên mật khẩu đăng nhập?</Title>
        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: 'Vui lòng nhập email!' },
            { type: 'email', message: 'Email sai định dạng' },
          ]}
        >
          <Input
            placeholder="Nhập Email đăng nhập"
            onChange={(e) => {
              setEmail(e.currentTarget.value);
            }}
          />
        </Form.Item>

        <Form.Item>
          <Button loading={isSubmiting} block type="primary" htmlType="submit">
            Tiếp tục
          </Button>
        </Form.Item>
        <Form.Item>
          <ForgotPasswordText onClick={() => navigate('/login')}>
            ← Đăng nhập tài khoản khác
          </ForgotPasswordText>
        </Form.Item>
      </Form>
    </Layout>
  );
};

export default ForgotPass;
